module.exports = __webpack_public_path__ + "img/bg-call.5f7c426d.png";